<template>
  <div>
    <div class="info-top wrapper-secondary text-decoration">
      <div class="info-description">
        <span class="info-pre-text">
          {{ $t("Unique_filters") }}
        </span>
        <h3 class="info-title">
          {{ $t("info_title") }}
        </h3>
        <p class="info-text">
          {{ $t("info_description") }}
          (Live)
        </p>
      </div>
      <div class="info-picture">
        <picture>
          <!-- <source media="(max-width: 767px)" srcset="pic/picture/picture-description-up-mob.webp" type="image/webp" />
          <source media="(max-width: 767px)" srcset="pic/picture/picture-description-up-mob.png" />
          <source media="(max-width: 1023px)" srcset="pic/picture/picture-description-up-tablet.webp"
            type="image/webp" />
          <source media="(max-width: 1023px)" srcset="pic/picture/picture-description-up-tablet.png" />
          <source srcset="pic/picture/picture-description-up.webp" type="image/webp" />
          <img src="pic/picture/picture-description-up.png" width="555" height="395" alt="picture" loading="lazy"/> -->
          <img
            :src="filterSrc"
            alt="picture"
            loading="lazy"
            class="first_img"
          />
        </picture>
      </div>
    </div>

    <div class="info-bottom">
      <div class="wrapper-secondary">
        <div class="settings__item--picture">
          <picture>
            <!-- <source media="(max-width: 767px)" srcset="pic/picture/picture-description-left-mob.webp"
              type="image/webp" />
            <source media="(max-width: 767px)" srcset="pic/picture/picture-description-left-mob.png" />
            <source media="(max-width: 1023px)" srcset="
                            pic/picture/picture-description-left-tablet.webp
                        " type="image/webp" />
            <source media="(max-width: 1023px)" srcset="pic/picture/picture-description-left-tablet.png" />
            <source srcset="pic/picture/picture-description-left.webp" type="image/webp" />
            <img src="pic/picture/picture-description-left.png" width="540" height="287" alt="picture" loading="lazy"/> -->
            <img :src="waterSrc" alt="picture" loading="lazy" />
          </picture>
        </div>
        <div class="info-small">
          <span class="info-pre-text">
            {{ $t("info_pre_text") }}
          </span>
          <h3 class="info-title">
            {{ $t("info_pre_title") }}
          </h3>
          <p class="info-text">
            {{ $t("info_text") }}
          </p>
        </div>
      </div>

      <div class="wrapper-secondary">
        <div class="settings__item--picture">
          <picture>
            <!-- <source media="(max-width: 767px)" srcset="pic/picture/picture-description-left-mob.webp"
              type="image/webp" />
            <source media="(max-width: 767px)" srcset="pic/picture/picture-description-left-mob.png" />
            <source media="(max-width: 1023px)" srcset="
                            pic/picture/picture-description-left-tablet.webp
                        " type="image/webp" />
            <source media="(max-width: 1023px)" srcset="pic/picture/picture-description-left-tablet.png" />
            <source srcset="pic/picture/picture-description-left.webp" type="image/webp" />
            <img src="pic/picture/picture-description-left.png" width="540" height="287" alt="picture" loading="lazy"/> -->
            <img :src="signalSrc" alt="picture" loading="lazy" />
          </picture>
        </div>
        <div class="info-small">
          <span class="info-pre-text">
            {{ $t("Signals") }}
          </span>
          <h3 class="info-title">
            {{ $t("info_title2") }}
          </h3>
          <p class="info-text">
            {{ $t("info_text2") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Info",
  computed: {
    waterSrc() {
      return this.isDarkTheme
        ? "/pic/subscribe/info/dark-w810-water.jpg"
        : "/pic/subscribe/info/light-w810-water.jpg";
    },
    signalSrc() {
      return this.isDarkTheme
        ? "/pic/subscribe/info/dark-w540-signal.jpg"
        : "/pic/subscribe/info/light-w540-signal.jpg";
    },
    filterSrc() {
      return this.isDarkTheme
        ? "/pic/subscribe/info/dark-w833-filter.jpg"
        : "/pic/subscribe/info/light-w833-filter.jpg";
    },
    isDarkTheme() {
      return this.$store.getters.isDarkTheme;
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../../scss/variables" as *;

.info-top {
  display: flex;
  justify-content: center;
  text-align: center;
  gap: 25px;
  margin-bottom: 25px;
}

.info-bottom {
  display: flex;
  justify-content: center;
  gap: 25px;
}

.info-description {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  width: 45.417%;
}

.info-small {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 10px 0;
  padding: 50px 4% 30px;
}

.info-title {
  padding: 0;
  line-height: 1.2;
  font-weight: 600;
  text-align: inherit;
  letter-spacing: -0.02em;
  color: var(--back-color);
  font-size: 44px;
  margin: 0;
}

.info-text {
  text-align: inherit;
}

.info-pre-text {
  color: var(--brand-color);
  font-weight: 800;
  text-align: center;
}
picture {
  position: relative;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}
img {
  border-radius: 26px;
  box-shadow: 0px 190.67px 143px -28.6px #0a043c14;
  height: 250px;
  object-fit: cover;
}
.first_img {
  height: 380px;
}
@media screen and (max-width: 1160px) {
  img {
    height: 220px;
  }
  .first_img {
    height: 340px;
  }
}
@media screen and (max-width: $desktop) {
  .info-top {
    flex-direction: column-reverse;
    align-items: center;
  }
  .info-bottom {
    flex-direction: column;
  }
  .info-title {
    font-size: 28px;
  }
  .info-small {
    align-items: center;
  }
  .info-description {
    width: unset;
  }
  img {
    height: 410px;
  }
  .first_img {
    height: 550px;
  }
}
@media screen and (max-width: 950px) {
  img {
    height: 350px;
  }
  .first_img {
    height: 450px;
  }
}

@media screen and (max-width: 820px) {
  img {
    height: 290px;
  }
  .first_img {
    height: 380px;
  }
}

@media screen and (max-width: 600px) {
  img {
    height: 250px;
  }
  .first_img {
    height: 340px;
  }
}

@media screen and (max-width: $mobile) {
  img {
    border-radius: 16px;
    height: 170px;
  }
  .first_img {
    height: 250px;
  }
}
</style>
